import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { tagline, socialLinks } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black text-white border-t-4 border-yellow-500">
      <div className="container mx-auto px-4 py-12">
        {/* Tagline Section */}
        <div className="text-center mb-8 pb-8 border-b-2 border-yellow-500">
          <p className="text-2xl md:text-3xl font-black text-yellow-400 italic">
            "{tagline}"
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <h3 className="text-3xl font-black mb-4">
              <span className="text-yellow-400" style={{ fontFamily: "'Fredoka One', cursive" }}>देशी</span>
              <span className="text-yellow-500" style={{ fontFamily: "'Bebas Neue', sans-serif", letterSpacing: '2px', fontSize: '33px' }}> STUFF</span>
            </h3>
            <p className="text-gray-300 font-medium mb-4">
              Authentic Punjabi stuffed parathas. Loaded with butter, stuffed with love.
            </p>
            <div className="space-y-2">
              <a href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-yellow-400 hover:text-yellow-300 font-bold transition-colors">
                <Instagram className="w-5 h-5" />
                <span>Follow us on Instagram</span>
              </a>
              <a href={socialLinks.zomato} target="_blank" rel="noopener noreferrer" className="text-yellow-400 hover:text-yellow-300 font-bold block transition-colors">
                Order on Zomato
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-400">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/menu" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium">
                  Our Menu
                </Link>
              </li>
              <li>
                <Link to="/locations" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium">
                  Locations
                </Link>
              </li>
              <li>
                <Link to="/franchise" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium">
                  Franchise Opportunity
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 text-yellow-400" />
                <a href="tel:9601382424" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium">
                  9601382424
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 text-yellow-400" />
                <a href="mailto:desistuff2016@gmail.com" className="text-gray-300 hover:text-yellow-400 transition-colors font-medium">
                  desistuff2016@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 text-yellow-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300 font-medium">
                  6 outlets across Ahmedabad
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-lg font-bold mb-4 text-yellow-400">Opening Hours</h4>
            <div className="space-y-2 text-gray-300 font-medium text-sm">
              <p className="font-bold text-white">Varies by location</p>
              <p>Lunch: 12:00 PM - 3:00 PM</p>
              <p>Dinner: 6:00 PM - 12:00 AM</p>
              <p className="text-xs mt-4">
                Check individual outlet timings on Locations page
              </p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400 font-medium">
            © 2025 देशी Stuff. All rights reserved. | Butter. Stuffing. Satisfaction.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
